import { z } from 'zod';
import { NEW_CREDIT_CARD_VALUE } from '../../../../constants';
import {
    createExternalCardPaymentForNewCardSchema,
    createExternalCardPaymentForSelectedCardSchema,
} from '../ExternalCardPaymentForm/schema';
import { ProcessPaymentFormField } from '../ProcessPaymentFormSchema';

export enum ExternalPreauthorizationFormField {
    Code = 'code',
    SequenceCode = 'sequenceCode',
}

const createExternalPreauthorizationBaseSchema = z.object({
    [ProcessPaymentFormField.Amount]: z.number().gt(0),
    [ExternalPreauthorizationFormField.Code]: z.string().optional(),
    [ExternalPreauthorizationFormField.SequenceCode]: z.string().optional(),
});

export const createExternalPreauthorizationForSelectedCardSchema = (
    optionalCreditCardPaymentDetailsEnabled: boolean
) => {
    const existingCardSchema = createExternalCardPaymentForSelectedCardSchema(optionalCreditCardPaymentDetailsEnabled);
    return existingCardSchema.merge(createExternalPreauthorizationBaseSchema);
};

export const createExternalPreauthorizationForNewCardSchema = (optionalCreditCardPaymentDetailsEnabled: boolean) => {
    const newCardSchema = createExternalCardPaymentForNewCardSchema(optionalCreditCardPaymentDetailsEnabled);
    return newCardSchema.merge(createExternalPreauthorizationBaseSchema);
};

export const isExternalPreauthorizationForNewCardFormValues = (
    values: ExternalPreauthorizationFormValues
): values is ExternalPreauthorizationNewCardFormValues => values.paymentMethodId === NEW_CREDIT_CARD_VALUE;

type ExternalPreauthorizationForSelectedCardFormValues = z.infer<
    ReturnType<typeof createExternalPreauthorizationForSelectedCardSchema>
>;

type ExternalPreauthorizationNewCardFormValues = z.infer<
    ReturnType<typeof createExternalPreauthorizationForNewCardSchema>
>;

export type ExternalPreauthorizationFormValues =
    | ExternalPreauthorizationForSelectedCardFormValues
    | ExternalPreauthorizationNewCardFormValues;
